import React, { useRef } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { Formik, Form as FormikForm } from "formik";
import MDInput from "components/MDInput";
import MDBox from "components/MDBox";

import ModalHeaderTitle from "./Header";
import {
  createPromotionApi,
  editPromotionApi
} from "services/api/dashboardApi";
import { Promotion } from "types/Promotion";

const initialValues = {
  title: "Enjoy a 10% discount every day from 3 PM to 4 PM!",
  body: ""
};
type Prop = {
  open: boolean;
  isEdit: boolean;
  handleClose: (refreshed?: boolean) => void;
  addPromotion: (promotionName: string) => void;
  selectedPromotion?: Promotion;
};
const PromotionModal: React.FC<Prop> = (props) => {
  const { open, handleClose, addPromotion, isEdit, selectedPromotion } = props;
  const accessToken = localStorage.getItem("stmpz-token") || "";
  const businessId = localStorage.getItem("stmpz-business-id") || "";
  const formikRef = useRef<any>(null);

  const handleOnClose = (_: {}, reason: "backdropClick" | "escapeKeyDown") => {
    if (reason === "backdropClick") {
      console.info("Backdrop is clicked");
    } else {
      handleClose(false);
    }
  };
  const onSubmit = async (values) => {
    try {
      if (isEdit) {
        await editPromotionApi(
          accessToken,
          businessId,
          selectedPromotion?.id || "",
          values.title,
          values.body
        );
      } else {
        await createPromotionApi(
          accessToken,
          businessId,
          values.title,
          values.body
        );
      }
    } catch (error) {
      alert(`Created Failed: ${error}`);
    } finally {
      handleClose(true);
    }

    addPromotion(values.name);
  };

  return (
    <div>
      <Dialog
        onClose={handleOnClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
        maxWidth={"md"}
        disableEscapeKeyDown={true}
        onBackdropClick={(event) => {
          event.stopPropagation();
          return false;
        }}
      >
        <ModalHeaderTitle
          id="customized-dialog-title"
          onClose={() => handleClose()}
        >
          {`${isEdit ? "Edit" : "Add"} Promotion`}
        </ModalHeaderTitle>
        <DialogContent dividers>
          <Formik
            initialValues={
              isEdit && selectedPromotion ? selectedPromotion : initialValues
            }
            onSubmit={onSubmit}
            innerRef={formikRef}
          >
            {({ values, errors, handleBlur, handleChange, setFieldValue }) => (
              <FormikForm>
                <MDBox width={"100%"} mr={5}>
                  <MDInput
                    type="text"
                    label="Promotion Title"
                    name="title"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.title}
                    fullWidth
                    error={!!errors.title}
                    helperText={errors.title}
                  />
                </MDBox>

                <MDBox width={"100%"} mr={5} mt={2}>
                  <MDInput
                    type="text"
                    label="Description"
                    name="body"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.body}
                    fullWidth
                    error={!!errors.body}
                    helperText={errors.body}
                  />
                </MDBox>
              </FormikForm>
            )}
          </Formik>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              //Trigger formik button as outside the form
              if (formikRef.current) {
                formikRef.current.handleSubmit();
              }
            }}
          >
            {`${isEdit ? "Edit" : "Add"} Promotion`}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default PromotionModal;
